import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { SwitchableOption } from '../../schema/switchable.schema';
import styles from '../../assets/css/dropdown.module.css';
import FormElementComponent from '../form/FormElement';
import { FormDataValue } from '../../hooks/useFormData';
import ChevronIcon from '../choice/ChevronIcon';

interface DropdownComponentProps {
	options: Array<SwitchableOption>;
	currentOption: string;
	handleChange: (value: string) => void;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const DropdownComponent: React.FC<DropdownComponentProps> = ({
	options,
	currentOption,
	handleChange,
	onChange,
	onValidationChange
}) => {
	return (
		<div className={styles.dropdown}>
			<FormControl fullWidth className={styles['dropdown-select']}>
				<InputLabel style={labelStyles}>Select an option</InputLabel>
				<Select
					labelId="dropdown-label"
					value={currentOption}
					onChange={(event) => handleChange(event.target.value as string)}
					IconComponent={ChevronIcon}
				>
					{options.map((option) => (
						<MenuItem key={option.value} value={option.value} disabled={option.disabled}>
							{option.label}
							{option.description && (
								<span className={styles['dropdown-option-description']}>{option.description}</span>
							)}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<div className={styles['dropdown-content']}>
				{options
					.find((option) => option.value === currentOption)
					?.content.map((element, index) => (
						<div key={index}>
							{' '}
							<FormElementComponent
								element={element}
								onChange={onChange}
								onValidationChange={onValidationChange}
							/>
						</div>
					))}
			</div>
		</div>
	);
};

export default DropdownComponent;

const labelStyles: React.CSSProperties = {
	position: 'absolute',
	top: '0',
	backgroundColor: '#ffffff',
	paddingLeft: '5px',
	zIndex: 1,
	fontSize: '19px'
};
